<div class="skeleton">
  <div class="skeleton__filter"></div>
  <div class="skeleton__filter"></div>
  <div class="skeleton__filter-button"></div>

  @for (button of numberOfButtons; track index; let index = $index) {
    <div class="skeleton__button"></div>
  }
</div>
